<template>
  <!--兑换-->
  <div id="app" >
    <van-col span="24" class="my_peach_bg">
        <!-- 我的桃花币 -->
        <van-col span="24" class="my_peach_title">
          <van-col span="24" class="my_peach_name">{{ $t('other.my') }}{{ currency_name }}</van-col>
          <van-col span="24" class="my_peach_coins">{{ coin }}</van-col>
<!--          <van-col span="12" offset="6">-->
<!--            <van-button round class="my_earnings_tx" type="default">{{ $t('other.Accumulative_withdrawal') }}:{{ coinall }}</van-button>-->
<!--          </van-col>-->
        </van-col>
        <van-col span="24" class="my_peach_content">
          <van-col span="22" offset="1" class="my_exchange_name">{{ $t('column.exchange')}}</van-col>
          <van-col span="22" offset="1">
            <van-col span="8" v-for="top in list" :key="top.id" class="my_exchange_type">
              <van-col span="24" @click="top_money(top.id)" :class="[styles == top.id ? 'my_exchange_type_borders' :'my_exchange_type_border']">
                <van-col span="24" class="my_exchange_type_img" if="style == top.id">
                  <img src="../assets/img/coin-grey.jpg" style="width: 35%;height: 35%;" v-if="styles == top.id">
                  <img src="../assets/img/coin-grey.jpg" style="width: 35%;height: 35%;" v-else>
                </van-col>
                <van-col span="24" class="my_exchange_type_val">
                  <!--  {{top.earnings}}-->
                </van-col>
                <van-col span="24" class="my_exchange_type_coin">
                  {{ top.earnings }} {{currency_name}}
                </van-col>
              </van-col>
            </van-col>

          </van-col>
        </van-col>
        <van-col span="18" offset="3" class="my_exchange_type_btn">
          <van-button type="primary" size="large" class="my_information_btn" @click="top_sure">{{ $t('btn.Confirm_exchange') }}</van-button>
        </van-col>
    </van-col>
  </div>
</template>

<script>
  //请求接口组件
  import '@/assets/css/style.css'
  import Toast from "vant/lib/toast"
  import axios from 'axios'
  export default {
    name: 'Index',
    data:function() {
      return {
        coin:'',
        coinall:'',
        list:[],
        currency_name:'',
        styles:'0'
      }
    },
    created: function() {
      this.convert();
      document.title = this.$t('title.exchange')
    },
    methods: {
      // 兑换列表
      top_money:function (id){
        this.styles=id
      },
      // 确认兑换
      top_sure: function(){
          if(this.styles == 0){
            Toast(this.$t('Tips.Select_exchange_type'))
            return false
          }
          const uid = this.$route.query.uid
          const token = this.$route.query.token
          axios.get(this.baseUrlApi + "mapi/public/index.php/api/Exchange_api/exchange_post_coin", {
            params: {
              uid: uid,
              token: token,
              id: this.styles
            }
          }).then(res => {
            Toast(res.data.msg)
            if (res.data.code == 1) {
              this.convert()
            }
          })
      },
      convert: function() {
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        axios.get(this.baseUrlApi+"mapi/public/index.php/api/Exchange_api/integral",{ params:{ uid:uid,token:token }}).then(res =>{
          console.log(res.data)
          this.list = res.data.list;
          this.currency_name = res.data.coin_name;
          this.coin = res.data.user.coin > 0 ? res.data.user.coin : 0 ;
          this.coinall = res.data.coinall > 0 ? res.data.coinall : 0 ;
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/exchange.vue